var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
// var Auth = require('../../resources/auth');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var StudentClassRes = require("../../resources/studentclass");
var apiDomain = env.domain.api;
// import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Link } from 'react-router';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import createConfirm from '../Modal/createConfirm';
import notification from '../Modal/notification';
import async from 'async';
import $ from 'jquery';
import '../../css/components/StudentClasses/StudentClasses.css';
import '../../css/components/StudentAnalytics/ViewStudentMistakesBank.css';
import '../../css/components/StudentAnalytics/StudentAttempt.css';
import Icon, { Ionicons } from 'react-web-vector-icons';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

var AnalyticsRes = require('../../resources/analytics');
var striptags = require('striptags');

var months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September',
    'October', 'November', 'December'
    ];

var StudentAttempt = React.createClass({

    retrieveMistakesForThisMonth: function() {

        var _this = this;
        var options = {};

      options.concept_config = {};
      options.concept_config.root = "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
      options.concept_config.leaf = true;
      options.concept_config.max_level = 4;

      options.conditions = {};

      var studentID = _this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

      // options.conditions.status = 'student';
      options.skip = 0;
      options.conditions.user = studentID;
      options.conditions.type = "USER_CONCEPT_PRACTICE";
      options.conditions.$or = [
          {
          "wrongAnswerCount": {
            "$gt": 0
          }
        }
      ];

      var dd = _this.state.day;
      var mm = _this.state.month;
      var yyyy = _this.state.year;

      if (dd < 10) {
        dd = '0' + dd;
      } 
      if (mm < 10) {
        mm = '0' + mm;
      } 

      var formattedStart = '' + yyyy + mm + '01';

      options.endTime = '' + yyyy + mm + dd; //end date here
      options.startTime = formattedStart; //start date here

      // options.conditions.status = 'student';

      //TODO: call a controller to actually retrieve the mistakes from the db server
      AnalyticsRes.retrieveStudentMistakesBankForMonth(options, function(err, res) {

        // if (res.length > 0) {
        //     console.log('Item: ', res);
        // }
        // _this.setState({
        //   isLoading: false,
        // //   data: (!err && res) ? res: [{}]
        // }, () => {
            var newDate = new Date(res.timeValue);
            var whichWeek = _this.getWeek(newDate.getFullYear(),newDate.getMonth()+1);
            console.log("WHICH WEEK: " + whichWeek);

            // console.log("RES LENGTH: " + JSON.stringify(res));
        if (res.length > 0) {
            console.log('Item: ', res);
            //get the date for this row
            var timeValue = res[0].timeValue;
            
            var mm = timeValue.substring(4,6);//timeValue.getDate();
            var dd = timeValue.substring(6,8);//timeValue.getMonth() + 1;

            //TODO: get the concept name for this using the concept id
            //get the concept ID
            var conceptID = res[0].concept;
            options.conceptID = conceptID;

            AnalyticsRes.retrieveConceptForMistake(options, function(err, resConcept) {

                console.log('CONCEPT: ', resConcept.title);

                _this.setState({
                    isLoading: false,
                    conceptTitle: resConcept.title,
                    conceptDay: dd,
                    conceptMonth: mm, //January is 0!
                    data: (!err && res) ? res: [{}]
                }, () => {
                
                });
            });
        } else {
            _this.setState({
                isLoading:false,
                conceptDay: 0,
                conceptMonth: 0,
                data: (!err && res) ? res: [{}]
            });
        }
            // if (res.length > 0) { _this.renderDataRows(res); }
      });
    //   });
    },

    renderEmptyColumns: function() {

        var result = [],
            _this = this;
        result.push(<td key={0} className="sortable mbColumn wrongQnsColumn">
                        
        </td>);
        result.push(<td key={1} className="sortable mbColumn wrongQnsColumn">
            
        </td>);
        result.push(<td key={2} className="sortable mbColumn wrongQnsColumn">
            
        </td>);
        return result;
    },

    renderLeftMostColumn: function(monthNumber,yearNumber,ifParentRow) {
        var result = [],
            _this = this;
        
        var monthName = months[monthNumber-1];
        
        if (!ifParentRow) {

            var mm = monthNumber;//_this.state.conceptMonth;
            var dd = yearNumber;//_this.state.conceptDay;

            // if (mm < 10) { mm = '0' + mm; }
            // if (dd < 10) { dd = '0' + dd; }

            return (
                <td key={'mistakeMonth'} className="sortable mbLeftColumn">
                    &nbsp;&nbsp;&nbsp;&nbsp;{dd}/{mm}
                </td>
            )
        }

        return (
            <td key={'mistakeMonth'} className="sortable mbLeftColumn">
                {monthName} {yearNumber}
            </td>
        )
    },

    renderNoDataRows: function() {

        var result = [],
            _this = this;
        result.push(<td key={0} className="sortable mbColumn wrongQnsColumn">
                        No data
                    </td>);
        result.push(<td key={1} className="sortable mbColumn">
                        
                    </td>);
        result.push(<td key={2} className="sortable mbColumn mbViewColumn">
                        
                    </td>);
        return result;
    },

    getWeek: function(year, month_number) {

        var firstOfMonth = new Date(year, month_number-1, 1);
        var lastOfMonth = new Date(year, month_number, 0);

        var used = firstOfMonth.getDay() + lastOfMonth.getDate();

        return Math.ceil( used / 7);
    },

    renderDataRows: function(data) {//, conceptsMap) {
        var result = [],
            _this = this;

        //TODO: get concept name by calling db using concept id again
        result.push(<td key="conceptName" className="mbColumn wrongQnsColumn">
                {_this.state.conceptTitle}
            </td>
        );

        //show number of wrong answers;
        result.push(<td key="wrongQuestions" className="mbColumn wrongQnsColumn">
                {data.wrongAnswerCount} / {data.totalAnswerCount}
            </td>
        );
        
        return result;
    },

    getInitialState: function() {

        var sAnswer = this.props.studentAnswer;
        var cAnswer = this.props.correctAnswer;
        var ifAnsweredCorrectly = "row createStudentRow mistakeSheetRow wrongAnswer answerRow"; //class names for when answered a question wrongly
        var ifAnsweredCorrectlyValue = "col DivlblCreateStuudent mistakeSheetText wrongStudentAns"; //if answered wrongly, display student's answer in red

        if (sAnswer === cAnswer) { 
            
            ifAnsweredCorrectly = "row createStudentRow mistakeSheetRow correctAnswer answerRow"; //class names for when answered a question correctly
            ifAnsweredCorrectlyValue = "col DivlblCreateStuudent mistakeSheetText rightStudentAns"; //if answered wrongly, display student's answer in green
        } 

        var finalCorrectAnswer = cAnswer;
        if (cAnswer.includes("<math xmlns")) {

            var fText = cAnswer.split("<mn>");
            var fAgain = fText[1].split("</mn>");
            finalCorrectAnswer = fAgain[0];
        }

        var pointText = " points";
        if (this.props.questionPoints < 2) { pointText = " point"; }

        return {
            // _id: this.props._id,
            data: [],
            isLoading: true,
            ifAnsweredCorrectly:this.props.ifAnsweredCorrectly,
            userSelectedChoice:this.props.userSelectedChoice,
            metadata:this.props.metadata,
            conceptTitle:this.props.metadata.mainConcepts[0].title,
            questionInfo:this.props.questionInfo,
            questionNumber: this.props.questionNumber,
            questionPoints: this.props.metadata.mainConcepts[0].title + " " + this.props.questionPoints + pointText,
            questionDesc: this.props.questionDesc,
            questionImage: this.props.questionImage,
            questionType: this.props.questionType,
            studentAnswer: this.props.studentAnswer, //for displaying the student's answer for MCQ questions
            correctAnswer: finalCorrectAnswer,//this.props.correctAnswer,
            ifAnsweredCorrectly: ifAnsweredCorrectly,
            ifAnsweredCorrectlyValue: ifAnsweredCorrectlyValue,
            solution: this.props.solution,
            textInputs: this.props.textInputs, //for display the student's answers for long structured questions
            textInputAnswers: this.props.textInputAnswers,
            mode: this.props.mode,
            sort: this.props.sort
        };
    },
    
    componentWillReceiveProps: function(nextProps) {
        this.setState({
          data: nextProps.data || this.state.data,
        //   conceptsMap: nextProps.conceptsMap || this.state.conceptsMap,
        //   mode: nextProps.mode || this.state.mode,
        //   sort: nextProps.sort || this.state.sort
        })
    },

    renderParts: function() {

        var result = [];
        var _this = this;
        var textInputAnswersLength = _this.state.textInputAnswers.length;

        for (var x = 0; x < textInputAnswersLength; x++) {

            var textInputAnswer = _this.state.textInputAnswers[x]; 
            result.push(

                <div className="mistakePartBox">
                    <div className="row createStudentRow">
                        <div className="col DivlblCreateStudent mistakeSheetText correctAnswerRow">
                            <div className="correctAnswerText">Correct answer: </div>
                            <div className="correctAnswerValue">{textInputAnswer.text}</div>
                        </div>
                    </div>

                    <div className="row createStudentRow">
                        <div className="col DivlblCreateStudent mistakeSheetText solutionRow">
                            <b>Solution:</b><br/>
                            {_this.renderSolution(_this.state.solution)}
                        </div>
                    </div>
                </div>
            );
        }
    },

    renderMCQ: function() {

        var _this = this;
        var result=[];
        var selectionChoices = this.state.questionInfo.selectionChoices;

        var userChoice = _this.state.userSelectedChoice; //get the user's selected choice too
        var cLength = selectionChoices.length;
        // console.log("USER CHOICE WAS ",userChoice);
        for (let x = 0; x < cLength; x++) {
            
            var eachChoice = selectionChoices[x];
        // selectionChoices.foreach(eachChoice=>{

            var textColor = '';
            var bgColor = '';
            var border='1px solid rgb(51,166,181)';

            var circleBorder = '1px solid black';
            // console.log("THIS CHOICE IS ",eachChoice);
        
            // if (!_this.state.ifAnsweredCorrectly) {

            var iconName = "ios-checkmark";
            var ifWrong = false;
            if (userChoice.length > 0) {

                if (eachChoice._id == userChoice[0]._id) { //if this question was answer wrongly, use red to indicate it
                    
                    if (userChoice[0].answerValue == 0) { //if 0 for user choice means answered wrongly
                        textColor = 'red';
                        bgColor = 'red';
                        border='1px solid red';
                        circleBorder = '1px solid red';
                        iconName = "ios-close";
                        ifWrong = true;
                    } 
                }
            }

            
            // const showIcon = null;
            // if (eachChoice.answerValue == 1 || ifWrong) { //only if this is the right or user's wrong answer
            //     showIcon = <Ionicons name={iconName} color='white' size={20}/>;
            // }
            // }
            var choice = <div style={ eachChoice.answerValue==0 ? { //if not correct answer
                    height:'35px',
                    width:'500px',
                    border:border,
                    padding:'5px 0px 5px 15px',
                    backgroundColor:'#efe4ec',
                    marginLeft:'20px',
                    color:textColor
                } 
                : { //if correct answer
                    height:'35px',
                    width:'500px',
                    border:'1px solid rgb(45,226,14)',
                    padding:'5px 0px 5px 15px',
                    backgroundColor:'#efe4ec',
                    marginLeft:'20px',
                }}>
                    {eachChoice.text}
                </div>

            if (eachChoice.image.length > 0) {

                choice = <div style={ eachChoice.answerValue==0 ? { //if not correct answer
                    height:'230px',
                    width:'500px',
                    maxWidth:'500px',
                    border:border,
                    padding:'5px 0px 5px 15px',
                    backgroundColor:'#efe4ec',
                    marginLeft:'20px',
                    color:textColor
                } 
                : { //if correct answer
                    height:'230px',
                    width:'500px',
                    maxWidth:'500px',
                    border:'1px solid rgb(45,226,14)',
                    padding:'5px 0px 5px 15px',
                    backgroundColor:'#efe4ec',
                    marginLeft:'20px',
                }}>
                    <img src={eachChoice.image} style={{
                        maxHeight:'200px',
                        maxWidth:'500px'
                    }} />
                </div>
            }

            result.push(
                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    marginBottom:'10px'
                }}>
                    <div style={ eachChoice.answerValue==0 ? { //if not correct answer
                        width:'36px',
                        height:'36px',
                        borderRadius:'18px',
                        border:circleBorder,//'1px solid black',
                        backgroundColor:bgColor
                    } 
                     : { //if correct answer
                        width:'36px',
                        height:'36px',
                        borderRadius:'18px',
                        border:'1px solid rgb(45,226,14)',
                        backgroundColor:'rgb(45,226,14)'
                    }}>
                        {/* {(eachChoice.answerValue == 1 || ifWrong) ? <Ionicons name={iconName} color='white' size={20}/> : "" } */}
                    </div>
                    
                    {choice}

                </div>
            );
        }

        return (
            <div className="mcq">
                {
                    result.map((data, index) => {
                        return data;
                    })
                }
            </div>
        );
    },

    renderSolution: function(solution) {

        var result = [];
        var _this = this;

        var arrayToLoop = solution; //if short questions, just loop through the solutions
        var numberOfSolutions = solution.length;

        // if (_this.state.questionType === 22) { //if long structured, loop through the sub items in the solution instead
            
        //     arrayToLoop = solution[0].subItems;
        // }

        var solutionCount = arrayToLoop.length;

        var ifNoSolution = false;
        
        if (solutionCount > 0) {
            
            for (var m = 0; m < 1; m++) {

                // if (_this.state.questionType === 22) { //if long structured, loop through the sub items in the solution instead

                //     arrayToLoop = solution[m].subItems;

                //     solutionCount = arrayToLoop.length;
                // }

                for (var i = 0; i < solutionCount; i++) {

                    var thisSolution = arrayToLoop[i]; 

                    var solutionValue = thisSolution.value;

                    var ifImage = false;
                    if (thisSolution.type!=null) {

                        if (thisSolution.type=='IMAGE') {

                            ifImage = true;
                            result.push(
                                <div className="solutionValue">
                                    <img src={solutionValue} width="300"/>
                                </div>
                            )
                        }
                    }

                    if (!ifImage) {

                        if (solutionValue.length > 0) {

                            var el = document.createElement('div');
                            el.innerHTML = solutionValue;
                            var html = el.textContent;
                            result.push(
                                <div className="solutionValue">{
                                    html
                                }</div>
                            );
                        } else {

                            ifNoSolution = true;
                        }
                    }
                }

                if (_this.state.questionType === 21) { break; } //if short questions, can break the outer loop as already added all the solutions. no need to go through sub items
            }

            // if (!ifNoSolution) {
            return (
                <div className="solutions">
                    {
                        result.map((data, index) => {
                            return data;
                        })
                    }
                </div>
            );
        }
        // } else {
        //     return (
        //         <div></div>
        //     )
        // }
    },

    renderLongParts: function(solution) {

        var result = [];
        var _this = this;

        var numberOfSolutions = solution.length;
        // console.log("WE HAVE NUM # SOLUTIONS: ", numberOfSolutions);

        for (var m = 0; m < numberOfSolutions; m++) {

            var thisSolution = solution[m];
            var textInputAnswer = _this.state.textInputAnswers[m];
            var textInput = _this.state.textInputs[m];
            var markText = "marks";

            if (textInputAnswer.answerValue < 2) { markText = "mark"; }

            var ifAnsweredCorrectly = "row createStudentRow mistakeSheetRow wrongAnswer answerRow"; //class names for when answered a question wrongly
            var ifAnsweredCorrectlyValue = "col DivlblCreateStuudent mistakeSheetText wrongStudentAns"; //if answered wrongly, display student's answer in red

            if (textInput.result === textInputAnswer.text) { //if answered correctly
                
                ifAnsweredCorrectly = "row createStudentRow mistakeSheetRow correctAnswer answerRow"; //class names for when answered a question correctly
                ifAnsweredCorrectlyValue = "col DivlblCreateStuudent mistakeSheetText rightStudentAns"; //if answered wrongly, display student's answer in green
            }

            var loopedSolution = [];
            var subItems = thisSolution.subItems;
            var subLength = subItems.length;

            for (var x = 0; x < subLength; x++) {
                var thisSubItem = subItems[x]; 

                var thisSubItemValue = thisSubItem.value;//.replace("&nbsp;","");
                // if (!thisSubItem.asHint) { //if this is not a hint, add it to the answer text
                    loopedSolution.push(
                        <div className='solutionValue'>{ReactHtmlParser(thisSubItemValue)}</div>
                    );
                // }
            }

            //format the text input if necessary (e.g if it has a <math xmlns bla bla)
            var finalCorrectAnswer = textInputAnswer.text;
            if (textInputAnswer.text.includes("<math xmlns")) {

                var fText = textInputAnswer.text.split("<mn>");
                var fAgain = fText[1].split("</mn>");
                finalCorrectAnswer = fAgain[0];
            }

            var textInputDesc = textInputAnswer.description;
            // textInputDesc = striptags(textInputAnswer.description);
            var extraDescWidth = [];
            // console.log("WIDTH IS ", textInputDesc.length);
            if (textInputDesc.length < 60) {
                extraDescWidth.push(
                    <div>
                    </div>
                );                                                                                          
            }

            var el = document.createElement('div');
            el.innerHTML = textInputDesc;
            var html = el.textContent;
            // result.push(
            //     <div className="solutionValue">{
            //         html
            //     }</div>
            // );

            var thisAnswer = textInput.text;
            // var thisCorrectAnswer = textInputAnswer.text;
            var thisResult = textInput.result;

            if (thisAnswer == null) { thisAnswer = thisResult; }

            if (thisAnswer.includes("<math xmlns")) {

                var splitAns = thisAnswer.split("<mn>");
                var ans = splitAns[1]; //this will give us 0</mn>blablabla and we want the 0
        
                var sAns = ans.split("</mn>");
                thisAnswer = sAns[0]; //this will give us the 0
            }

            if (thisResult!=null) {
                if (thisResult.includes("<math xmlns")) {

                    var splitAns = thisResult.split("<mn>");
                    var ans = splitAns[1]; //this will give us 0</mn>blablabla and we want the 0
            
                    var sAns = ans.split("</mn>");
                    thisResult = sAns[0]; //this will give us the 0
                }
            } else {
                thisResult = thisAnswer;
            }

            // if (thisCorrectAnswer.includes("<math xmlns")) {

            //     var splitAns = thisCorrectAnswer.split("<mn>");
            //     var ans = splitAns[1]; //this will give us 0</mn>blablabla and we want the 0
        
            //     var sAns = ans.split("</mn>");
            //     thisCorrectAnswer = sAns[0]; //this will give us the 0
            // }

            thisAnswer = striptags(thisAnswer);
            thisResult = striptags(thisResult);

            thisAnswer = thisAnswer.replace(/&nbsp;/g," ");
            thisResult = thisResult.replace(/&nbsp;/g," ");

            var thisPretext = textInputAnswer.preText;//.replace(""," ");
            result.push(
                <div className="mistakePartBox">
                    <div className="mistakePartTitle"><b>Part {m+1} - {textInputAnswer.answerValue} {markText}</b></div>
                    <div className="mistakePartQuestion">{html}{extraDescWidth}</div>
                    <hr/>
                    <div className="col DivlblCreateStudent mistakeSheetText solutionRow">
                        <b>Answer</b><br/>
                        <textarea className="mistakePartStudentAnswer" rows="6" readonly="readonly" disabled="true">{thisAnswer}</textarea>
                    </div>
                    <div className="finalResultTitle mistakePartTitle"><b>Final Result</b></div>
                    <div className="finalResultAnswer">
                        <div className="finalResultPreText"><b>{thisPretext}</b></div>
                        <div className="finalResultValue">
                            <div className={ifAnsweredCorrectly}>
                                <div className={ifAnsweredCorrectlyValue}>{thisResult}</div>
                            </div>
                        </div>
                    </div>
                    <div className="correctAnswerSection">
                        <div className="correctAnswerText">Correct Answer:</div>
                        <div className="correctAnswerValue">{finalCorrectAnswer}</div>
                    </div>
                    <div className="row createStudentRow mistakeDescRow longSolutionRow">
                        <div className="col DivlblCreateStuudent mistakeSheetText">
                            <b>Solution:</b><br/>
                            {loopedSolution}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="solutions">
                {
                    result.map((data, index) => {
                        return data;
                    })
                }
            </div>
        );
    },

    displayQuestion: function() {

        var _this = this;
        if (this.state.questionImage!=null) {

            if (this.state.questionImage.length > 0) {

                return (
                    <div className="col DivlblCreateStuudent mistakeSheetText">
                        {striptags(_this.state.questionDesc)}<br/>
                        <img src={this.state.questionImage} className="studentAttemptImg"/>
                    </div>
                )
            }
        } 

        // var result = [];
        // var el = document.createElement('div');
        // el.innerHTML = _this.state.questionDesc;
        // var html = el.textContent; //textContent
        // result.push(
        //     <div className="">{
        //         el
        //     }</div>
        // );

        // var html = el.firstChild;

        return (
            <div className="col DivlblCreateStuudent mistakeSheetText">
                {/* {striptags(_this.state.questionDesc)} */}
                {/* {
                    result.map((data, index) => {
                        return data;
                    })
                } */}
                {ReactHtmlParser(_this.state.questionDesc)}
            </div>
            
        )
    },

    render: function() {
        
        var _this = this;

        // const actions = [
        //     <FlatButton
        //         label="Cancel"
        //         primary={true}
        //         onTouchTap={this.closeAssignTaskModal}
        //     />,
        //     <RaisedButton
        //         label={this.state.assignType === 'assign' ? "Assign" : "Re-assign"}
        //         primary={true}
        //         onClick={this.doAssign}/>
        // ];
        return (
            <div>
                { 
                   (!_this.state.isLoading) &&
                   <div className="mistakesPage">
                        <div className="row createStudentRow">
                            <div className="DivlblCreateStudent mistakeNumberPoints">
                                <label className="lblCreateStudent lblQuestionNumber">{_this.state.questionNumber}</label>
                                <label className="lblCreateStudent lblQuestionPoints">{_this.state.questionPoints}</label>
                            </div>
                        </div>

                        <div className="row createStudentRow mistakeSheetRow mistakeDescRow" style={{
                            marginBottom:'25px'
                        }}>
                            {_this.displayQuestion()}
                        </div>
                        <br/><br/>
                        {
                            (this.state.questionType === 11) && //if mcq type, display the 4 choices
                            _this.renderMCQ()
                        }

                        {
                            (this.state.questionType === 11 && _this.state.solution.length>0) &&
                            <div className="row createStudentRow">
                                <div className="col DivlblCreateStudent mistakeSheetText solutionRow">
                                    <b>Solution</b><br/>
                                    {_this.renderSolution(_this.state.solution)}
                                </div>
                            </div>
                        }

                        {
                            (this.state.questionType === 21) &&
                            <div>
                                <div className={_this.state.ifAnsweredCorrectly}>
                                    <div className={_this.state.ifAnsweredCorrectlyValue}>
                                        {_this.state.studentAnswer}
                                    </div>
                                </div>

                                <div className="row createStudentRow">
                                    <div className="col DivlblCreateStudent mistakeSheetText correctAnswerRow">
                                        <div className="correctAnswerText">Correct answer: </div>
                                        <div className="correctAnswerValue">{_this.state.correctAnswer}</div>
                                    </div>
                                </div>

                                <div className="row createStudentRow">
                                    <div className="col DivlblCreateStudent mistakeSheetText solutionRow">
                                        <b>Solution:</b><br/>
                                        {_this.renderSolution(_this.state.solution)}
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            (this.state.questionType === 22) &&
                            <div className="createStudentRow solutionRow">
                                
                                    
                                {_this.renderLongParts(_this.state.solution)}
                                 
                                
                            </div>
                        }
                    </div>
                }
                {
                _this.state.isLoading &&
                <CircularProgress />
                }
            </div>
        );
    },

    componentDidMount: function() {
        this.setState({
            isLoading: false
        })
        // this.retrieveMistakesForThisMonth();
    },
});

module.exports = StudentAttempt;




/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/StudentAttempt.js
 **/